import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { get, map } from 'lodash';
import Link from 'react-router/lib/Link';
import Money from '../../../common/money';
import { canUserModifyServices } from '../../../common/helpers/users';
import Icon, { GLYPHS } from '../../../common/icon';
import { isBrandViewActive } from '../../../auth/selectors';

class ServiceListItem extends Component {
  onClick = (e) => {
    e.preventDefault();
  };

  getTax() {
    const taxes = get(this.props, 'service.taxes', []);
    if (!taxes.length) return '-';
    return map(taxes, (tax, index) => (
      <div key={`${index}-${tax.percentage}`}>{`${tax.name} ${tax.percentage}%`}</div>
    ));
  }

  getCategory() {
    const categories = get(this.props, 'service.categories', []);
    if (categories.length) {
      return map(
        categories,
        category => <span key={category.id} className="u-block">{category.name}</span>
      );
    }
    return '-';
  }

  getDetailsUrl = () => {
    const {
      service: { id },
      barberUser,
      isBrandUser,
    } = this.props;

    if (isBrandUser) {
      return `/brand/services/${id}`;
    }

    if (barberUser) {
      return `/barber/services/${id}`;
    }

    return `/services/${id}`;
  }

  render() {
    const {
      service,
      permissions,
      isBrandUser,
    } = this.props;
    const { name, duration, cost, enabled } = service;

    const detailsUrl = this.getDetailsUrl();

    const linkClass = classNames(
      'c-table-card__row is-sortable',
      { 'no-pointer-events': !canUserModifyServices(permissions) },
    );

    const canUserSortServices = canUserModifyServices(permissions) && !isBrandUser;

    return (
      <Link className={linkClass} to={detailsUrl}>
        <div
          className="c-table-card__cell u-1/10 u-1/16-large-and-up"
          onClick={this.onClick}
          onTouchMove={this.onClick}
          display-if={canUserSortServices}
        >
          <div className="c-link-blank u-text-right u-pr- u-align-middle sortable-handle">
            <Icon glyph={GLYPHS.dragDrop} size="medium" />
          </div>
        </div>
        <div
          className={`c-table-card__cell ${canUserSortServices ?
            'u-2/10 u-3/16-large-and-up' :
            'u-3/10 u-4/16-large-and-up'}`}
        >
          {name}
        </div>
        <div className="c-table-card__cell u-1/10 u-2/16-large-and-up">
          {duration} min
        </div>
        <div className="c-table-card__cell u-1/10 u-2/16-large-and-up">
          <Money cents={cost} />
        </div>
        <div className="c-table-card__cell u-2/10 u-3/16-large-and-up">
          {this.getTax()}
        </div>
        <div className="c-table-card__cell u-2/10 u-3/16-large-and-up">
          <div>
            {this.getCategory()}
          </div>
        </div>
        <div className="c-table-card__cell u-1/10 u-2/16-large-and-up">
          {enabled ? 'Enabled' : 'Disabled'}
        </div>
      </Link>
    );
  }
}

ServiceListItem.propTypes = {
  service: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  barberUser: PropTypes.object,
  isBrandUser: PropTypes.bool,
};

ServiceListItem.defaultProps = {
  barberUser: null,
  isBrandUser: false,
};

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
  permissions: state.auth.permissions,
  isBrandUser: isBrandViewActive(state),
});

export default connect(mapStateToProps)(ServiceListItem);
